<template>
    <div id="view">
        <div class="head">
            <div class="left">
                <div class="head_icon">
                    <span :class="icon"></span>
                </div>
                <div class="title">
                    {{ title }}
                </div>
                <div class="en_title">{{ enTitle }}</div>
            </div>
            <div class="right">
                <span class="click_more" @click="$router.push('/ArticleInit/list?articleModel=' + articleModel + '&isHomePage=' + isHomePage)">更多>></span>
            </div>
        </div>
        <div class="articl_list">
            <ul>
                <li v-for="item in articleList"
                    @click="$router.push('/ArticleInit/detail?articleId=' + item.articleId + '&articleModel=' + item.articleModel)">
                    <div class="date">
                        <div class="day">{{ item.dateStr.substr(8, 2) }}</div>
                        <div class="month">{{ item.dateStr.substr(5, 2) }}</div>
                    </div>
                    <div class="title"><span>{{ item.articleTitle }}</span></div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { apiService, RESULT_CODE } from "@/api/ApiService.js"
export default {
    name: 'ArcicleListWindowTwo',
    data() {
        return {
            articleList: []
        }
    },
    props: ['icon', 'title', 'articleModel', 'enTitle', 'isHomePage'],
    watch: { '$route': 'init' },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            let articleModel = this.articleModel
            let isHomePage = this.isHomePage
            apiService.findArticle({ articleModel, isHomePage, pageNum: 1, pageSize: 5 }).then(res => {
                if (res.code == RESULT_CODE.SUCCESS) {
                    this.articleList = res.rows
                }
            })
        }
    }
}
</script>
<style scoped>
#view {
    display: flex;
    flex-direction: column;
}

.head {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #6510ad;
    padding-bottom: 10px;
}

.click_more {
    white-space: nowrap;
    font-size: 14px;
    display: inline-block;
    position: absolute;
    right: 10px;
    bottom: 5px;
    cursor: pointer;
}

.en_title {
    margin-left: 10px;
}

.head>.left {
    display: flex;
}

.head>.left {
    font-size: 0.125rem;
    font-weight: 700;
    line-height: 00.125rem;
}

.head_icon {
    margin-right: 5px;
}

.head_icon>span {
    font-weight: 700;
    color: #23487e;
}

.head>.right {
    position: relative;
}

.head>.right>span {
    position: absolute;
    bottom: 0;
    right: 0;
}

.head>.right>span>a {
    text-decoration: none;
    font-size: 0.07rem;
    width: 0.28rem;
    display: inline-block;
    color: #2c3e50;
}

.articl_list {
    margin-top: 10px;
    padding: 0 5px;
    flex: 1;

}

.articl_list>ul {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.articl_list li {
    display: flex;
    height: 0.35rem;
    cursor: pointer;
}

.articl_list li:nth-child(2n-1) {
    background-color: #edededaa;

}

.articl_list li>.title {
    flex: 1;
    font-size: 0.08rem;
    line-height: 0.35rem;
}

.articl_list li>.title>span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #464646;
    width: 100%;
    display: inline-block;
}

.articl_list li>.date {
    width: 0.4rem;
    text-align: center;
    height: 0.35rem;
    display: flex;
    flex-direction: column;
    color: #336699;
    box-sizing: border-box;
    padding: 10px 20px;

}

.date>div {
    text-align: center;
}

.date>div:first-child {
    flex: 1;
    font-size: 0.08rem;
}

.date>div:last-child {
    flex: 1;
    box-sizing: border-box;
    border-bottom: 5px solid #336699;
    font-size: 0.125rem;
    font-weight: 700;
    line-height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/ArticleListWindowTwo.vue